import React from 'react';

// Third-party.
import Helper from "../helpers/Helper";

function GenericBreakdown(props: { individualTime: number, totalTime?: number, color: string, tooltip: string }) {

    if (props.totalTime === undefined) {
        return (
            <React.Fragment>-</React.Fragment>
        )
    }
    const percentage = (100 / props.totalTime) * props.individualTime;

    const weight: number = Helper.formatPercentage(percentage),
        tooltip: string = `${props.tooltip} (${weight}%)`;

    if (weight < 5) {

        // Less then 5% time spent - so we either don't care, or there are simply too many rows below 5%.
        return (
            <React.Fragment>-</React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div style={{ width: `${weight}%`, backgroundColor: props.color }} {...(props.tooltip ? { 'data-tooltip-id': 'global-tooltip', 'data-tooltip-content': tooltip } : {})}>&nbsp;</div>
        </React.Fragment>
    );
}

export default GenericBreakdown;
